import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import { coreAPI } from '../services/coreAPI'
import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDOOHLocationsReportTableFilters,
  TPPAdvertiserId,
} from '../models/types'
import { IDOOHReportingLocationsTableResponse } from '../models'
import {
  EReportColumnHeader,
  EReportingTimeWindow,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

export default function useGetAdvertiserReportingDOOHLocationsTableV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TDOOHLocationsReportTableFilters &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IDOOHReportingLocationsTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingDOOHLocationsTable_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    () => {
      return coreAPI
        .v2AdvertiserReporting()
        .getDOOHAdvertiserLocationsReportTable(
          advertiserId,
          generateCorrelationId(),
          retailerId,
          campaignId,
          adGroupId,
          sortBy as EReportColumnHeader,
          sortOrder,
          timeWindow as unknown as EReportingTimeWindow,
          startDate,
          endDate,
          tzZone || getTimezone(),
          pageLimit,
          pageOffset,
          filterBy,
          filterOperation,
          filterValue,
          name,
          // @ts-expect-error: fix in PORT-2535
          status
        )
    },
    { suspense, enabled }
  )
}
